import angular from 'angular';
import uiRouter from 'angular-ui-router';
import snapshotWidgetComponent from './snapshot-widget.component';

let snapshotWidgetModule = angular.module('snapshot-widget', [])

.component('snapshotWidget', snapshotWidgetComponent)

.name;

export default snapshotWidgetModule;



// WEBPACK FOOTER //
// ./client/app/common/snapshot-widget/snapshot-widget.js